// extracted by mini-css-extract-plugin
module.exports = {"splash-page":"_2hu71PI_j6e8CWnazXUpI","splash-page-actions-row":"_3nNhtEOZ7k_Qbm_m0GfBJM","splash-page-actions-col":"_3J4U7559-cGuJxm3yhht8E"};